module.exports = __webpack_public_path__ + "static/media/avive_aed_unaccepted_default.63111111.svg";